// extracted by mini-css-extract-plugin
export default {"header":"Header_header__mtodi","logo":"Header_logo__9YFPc","menu":"Header_menu__ddsbd","logout":"Header_logout__8hb+2","hamburguer":"Header_hamburguer__UhZbF"};